export const EXTENSIONS_EN = {
    'nav.module.extensions': 'Extra fields',
    'nav.extensions.fields': 'Extra fields',
    'screen.extensions.fields.title': 'Extra fields',
    'screen.extensions.fields.lede': 'The fields this workspace adds to another module’s records — a text, a number, a date or a choice, per entity — drawn after its declared columns and fields and carried into its export. A retired field hides; its values stay.',
    // ── what the shell composes ──
    'extensions.card': 'Extra fields',
    'extensions.section': 'Extra fields',
    'extensions.action.edit': 'Extra fields',
    'extensions.saved': 'The extra fields were saved.',
    'extensions.unsaved': 'Extra fields were not saved',
    'extensions.unsaved.detail': 'The record itself was saved. Its extra fields were not: {reason}',
    'extensions.unsaved.noId': 'the answer named no record to attach them to',
    'extensions.retry': 'Try again',
    'extensions.clientSide': 'Sorted and filtered here, from the rows in view',
    // ── the administrator's screen ──
    'extensions.admin.entity': 'Entity',
    'extensions.admin.entity.placeholder': 'Choose an entity',
    'extensions.admin.entity.help': 'Every list of an enabled module. A field added here appears after that list’s declared columns, on its create form and on its record page.',
    'extensions.admin.add': 'Add a field',
    'extensions.admin.edit': 'Edit',
    'extensions.admin.retire': 'Retire',
    'extensions.admin.retire.title': 'Retire «{field}»?',
    'extensions.admin.retire.description': 'It disappears from every screen and export. The values already typed stay, and the key is never given out again.',
    'extensions.admin.empty': 'No extra fields on this entity yet.',
    'extensions.admin.empty.description': 'A field added here is drawn after the declared columns and fields of every screen that shows this entity.',
    'extensions.admin.noEntity': 'Choose an entity to see its extra fields.',
    'extensions.admin.identityDown': 'Identity did not answer which entities this workspace has, so no field can be added right now.',
    'extensions.admin.col.key': 'Key',
    'extensions.admin.col.label': 'Label',
    'extensions.admin.col.type': 'Type',
    'extensions.admin.col.required': 'Required',
    'extensions.admin.col.in_reports': 'In lists and exports',
    'extensions.admin.col.guard': 'Guard',
    'extensions.admin.col.status': 'Status',
    'extensions.admin.type.text': 'Text',
    'extensions.admin.type.number': 'Number',
    'extensions.admin.type.date': 'Date',
    'extensions.admin.type.list': 'Choice',
    'extensions.admin.status.active': 'Active',
    'extensions.admin.status.retired': 'Retired',
    'extensions.admin.yes': 'Yes',
    'extensions.admin.no': 'No',
    'extensions.admin.field.key': 'Key',
    'extensions.admin.field.key.help': 'Lower-case letters, digits and underscores, starting with a letter. Fixed once saved.',
    'extensions.admin.field.type': 'Type',
    'extensions.admin.field.label_ar': 'Label (Arabic)',
    'extensions.admin.field.label_en': 'Label (English)',
    'extensions.admin.field.required': 'Required',
    'extensions.admin.field.options': 'Choices',
    'extensions.admin.field.options.help': 'One per line: value | Arabic | English',
    'extensions.admin.field.in_reports': 'Show in the list and carry into its export',
    'extensions.admin.field.guard': 'Guard',
    'extensions.admin.field.guard.none': 'None — the entity’s own permission is enough',
    'extensions.admin.field.guard.help': 'A permission a reader needs to see the value and a writer to set it. The entity’s own permission ({permission}) is always needed.',
    'extensions.admin.options.shape': 'Line {n} is not «value | Arabic | English».',
    'extensions.admin.saved': 'Saved.',
    'extensions.admin.retired': 'Retired.',
    // ── the store's refusals ──
    'extensions.refusal.key_shape': 'A key is lower-case letters, digits and underscores, starting with a letter, at most 40.',
    'extensions.refusal.type_unknown': '«{type}» is not a type an extra field takes: text, number, date or choice.',
    'extensions.refusal.guard_shape': 'A guard is a permission key: module.resource.action.',
    'extensions.refusal.flag_shape': '{field} is yes or no.',
    'extensions.refusal.key_taken': 'The key «{key}» is already used under this entity; a retired field keeps its key, because its values are still kept.',
    'extensions.refusal.entity_shape': 'An entity is named module.entity.',
    'extensions.refusal.entity_unknown': 'No list in this workspace shows «{entity}».',
    'extensions.refusal.entities_unavailable': 'Identity did not answer which entities this workspace has: {reason}',
    'extensions.refusal.too_many_fields': 'An entity takes at most {max} extra fields.',
    'extensions.refusal.no_field': 'No such field.',
    'extensions.refusal.retired': 'This field is retired; it is not edited or retired again.',
    'extensions.refusal.stale': 'Somebody changed this since you opened it. Open it again.',
    'extensions.refusal.version_shape': 'The version is the whole number the row was read at.',
    'extensions.refusal.entity_forbidden': 'The extra fields of this entity need {permission}.',
    'extensions.refusal.ids_shape': 'The ids are a list of record ids.',
    'extensions.refusal.too_many_ids': 'At most {max} records at once.',
    'extensions.refusal.id_shape': 'A record id is letters, digits, dot, dash, colon or underscore.',
    'extensions.refusal.no_fields': 'This entity has no extra fields.',
    'extensions.refusal.guarded': '«{field}» needs {permission}.',
    // ── the change record's words for what this module records ──
    'change.field.field.entity': 'Entity',
    'change.field.field.key': 'Key',
    'change.field.field.position': 'Position',
    'change.field.field.type': 'Type',
    'change.field.field.label_ar': 'Label (Arabic)',
    'change.field.field.label_en': 'Label (English)',
    'change.field.field.required': 'Required',
    'change.field.field.options': 'Choices',
    'change.field.field.in_reports': 'In lists and exports',
    'change.field.field.guard': 'Guard',
    'change.field.field.permission': 'Permission',
    'change.field.field.status': 'Status',
    'change.field.field.retired_at': 'Retired at',
    'change.field.field.retired_by': 'Retired by',
    'change.field.field.created_by': 'Added by',
    'change.field.values.entity': 'Entity',
    'change.field.values.values': 'Extra fields',
    'change.field.values.created_by': 'First written by',
    'change.field.values.updated_by': 'Last written by',
};
export const EXTENSIONS_AR = {
    'nav.module.extensions': 'الحقول الإضافية',
    'nav.extensions.fields': 'الحقول الإضافية',
    'screen.extensions.fields.title': 'الحقول الإضافية',
    'screen.extensions.fields.lede': 'الحقول التي تضيفها مساحة العمل إلى سجلّات مديول آخر — نص أو رقم أو تاريخ أو اختيار، لكل كيان — تُرسم بعد أعمدته وحقوله المعلنة وتُحمل في تصديره. الحقل المتقاعد يختفي، وقيمه تبقى.',
    // ── ما يركّبه الغلاف ──
    'extensions.card': 'حقول إضافية',
    'extensions.section': 'حقول إضافية',
    'extensions.action.edit': 'الحقول الإضافية',
    'extensions.saved': 'حُفظت الحقول الإضافية.',
    'extensions.unsaved': 'حقول إضافية لم تُحفظ',
    'extensions.unsaved.detail': 'حُفظ السجل نفسه، ولم تُحفظ حقوله الإضافية: {reason}',
    'extensions.unsaved.noId': 'الجواب لم يسمِّ سجلاً تُلحق به',
    'extensions.retry': 'حاول مجدداً',
    'extensions.clientSide': 'يُرتَّب ويُرشَّح هنا، من الصفوف المعروضة',
    // ── شاشة المدير ──
    'extensions.admin.entity': 'الكيان',
    'extensions.admin.entity.placeholder': 'اختر كياناً',
    'extensions.admin.entity.help': 'كل قائمة في مديول مفعّل. الحقل المضاف هنا يظهر بعد أعمدة تلك القائمة المعلنة، وفي نموذج الإنشاء، وفي صفحة السجل.',
    'extensions.admin.add': 'إضافة حقل',
    'extensions.admin.edit': 'تعديل',
    'extensions.admin.retire': 'تقاعد',
    'extensions.admin.retire.title': 'تقاعد «{field}»؟',
    'extensions.admin.retire.description': 'يختفي من كل شاشة وتصدير. القيم المكتوبة تبقى، والمفتاح لا يُمنح مرة أخرى.',
    'extensions.admin.empty': 'لا حقول إضافية على هذا الكيان بعد.',
    'extensions.admin.empty.description': 'الحقل المضاف هنا يُرسم بعد الأعمدة والحقول المعلنة في كل شاشة تعرض هذا الكيان.',
    'extensions.admin.noEntity': 'اختر كياناً لترى حقوله الإضافية.',
    'extensions.admin.identityDown': 'لم تُجب الهوية عن الكيانات الموجودة في مساحة العمل، فلا يمكن إضافة حقل الآن.',
    'extensions.admin.col.key': 'المفتاح',
    'extensions.admin.col.label': 'العنوان',
    'extensions.admin.col.type': 'النوع',
    'extensions.admin.col.required': 'مطلوب',
    'extensions.admin.col.in_reports': 'في القوائم والتصدير',
    'extensions.admin.col.guard': 'صلاحية إضافية',
    'extensions.admin.col.status': 'الحالة',
    'extensions.admin.type.text': 'نص',
    'extensions.admin.type.number': 'رقم',
    'extensions.admin.type.date': 'تاريخ',
    'extensions.admin.type.list': 'اختيار',
    'extensions.admin.status.active': 'نشط',
    'extensions.admin.status.retired': 'متقاعد',
    'extensions.admin.yes': 'نعم',
    'extensions.admin.no': 'لا',
    'extensions.admin.field.key': 'المفتاح',
    'extensions.admin.field.key.help': 'حروف لاتينية صغيرة وأرقام وشرطة سفلية، يبدأ بحرف. يثبت بعد الحفظ.',
    'extensions.admin.field.type': 'النوع',
    'extensions.admin.field.label_ar': 'العنوان (عربي)',
    'extensions.admin.field.label_en': 'العنوان (إنجليزي)',
    'extensions.admin.field.required': 'مطلوب',
    'extensions.admin.field.options': 'الخيارات',
    'extensions.admin.field.options.help': 'خيار في كل سطر: القيمة | عربي | إنجليزي',
    'extensions.admin.field.in_reports': 'يظهر في القائمة ويُحمل في تصديرها',
    'extensions.admin.field.guard': 'صلاحية إضافية',
    'extensions.admin.field.guard.none': 'لا شيء — صلاحية الكيان نفسها تكفي',
    'extensions.admin.field.guard.help': 'صلاحية يحتاجها القارئ ليرى القيمة والكاتب ليضعها. صلاحية الكيان نفسها ({permission}) مطلوبة دائماً.',
    'extensions.admin.options.shape': 'السطر {n} ليس «القيمة | عربي | إنجليزي».',
    'extensions.admin.saved': 'حُفظ.',
    'extensions.admin.retired': 'تقاعد.',
    // ── رفض المخزن ──
    'extensions.refusal.key_shape': 'المفتاح حروف لاتينية صغيرة وأرقام وشرطة سفلية، يبدأ بحرف، وأقصاه 40.',
    'extensions.refusal.type_unknown': '«{type}» ليس نوعاً يقبله الحقل الإضافي: نص أو رقم أو تاريخ أو اختيار.',
    'extensions.refusal.guard_shape': 'الصلاحية الإضافية مفتاح صلاحية: module.resource.action.',
    'extensions.refusal.flag_shape': '{field} نعم أو لا.',
    'extensions.refusal.key_taken': 'المفتاح «{key}» مستعمل تحت هذا الكيان؛ الحقل المتقاعد يحتفظ بمفتاحه لأن قيمه ما زالت محفوظة.',
    'extensions.refusal.entity_shape': 'الكيان يُسمّى module.entity.',
    'extensions.refusal.entity_unknown': 'لا قائمة في مساحة العمل هذه تعرض «{entity}».',
    'extensions.refusal.entities_unavailable': 'لم تُجب الهوية عن الكيانات الموجودة في مساحة العمل: {reason}',
    'extensions.refusal.too_many_fields': 'الكيان يقبل {max} حقلاً إضافياً على الأكثر.',
    'extensions.refusal.no_field': 'لا حقل بهذا المعرّف.',
    'extensions.refusal.retired': 'هذا الحقل متقاعد؛ لا يُعدَّل ولا يُتقاعد مرة أخرى.',
    'extensions.refusal.stale': 'غيّر أحدٌ هذا منذ فتحته. افتحه مجدداً.',
    'extensions.refusal.version_shape': 'الإصدار هو العدد الصحيح الذي قُرئ الصف عنده.',
    'extensions.refusal.entity_forbidden': 'الحقول الإضافية لهذا الكيان تحتاج {permission}.',
    'extensions.refusal.ids_shape': 'المعرّفات قائمة معرّفات سجلات.',
    'extensions.refusal.too_many_ids': '{max} سجلاً على الأكثر في المرة الواحدة.',
    'extensions.refusal.id_shape': 'معرّف السجل حروف وأرقام ونقطة وشرطة ونقطتان وشرطة سفلية.',
    'extensions.refusal.no_fields': 'هذا الكيان لا حقول إضافية له.',
    'extensions.refusal.guarded': '«{field}» يحتاج {permission}.',
    // ── كلمات سجل التغيير لما يسجّله هذا المديول ──
    'change.field.field.entity': 'الكيان',
    'change.field.field.key': 'المفتاح',
    'change.field.field.position': 'الترتيب',
    'change.field.field.type': 'النوع',
    'change.field.field.label_ar': 'العنوان (عربي)',
    'change.field.field.label_en': 'العنوان (إنجليزي)',
    'change.field.field.required': 'مطلوب',
    'change.field.field.options': 'الخيارات',
    'change.field.field.in_reports': 'في القوائم والتصدير',
    'change.field.field.guard': 'صلاحية إضافية',
    'change.field.field.permission': 'الصلاحية',
    'change.field.field.status': 'الحالة',
    'change.field.field.retired_at': 'تقاعد في',
    'change.field.field.retired_by': 'أتقاعده',
    'change.field.field.created_by': 'أضافه',
    'change.field.values.entity': 'الكيان',
    'change.field.values.values': 'الحقول الإضافية',
    'change.field.values.created_by': 'أول من كتبها',
    'change.field.values.updated_by': 'آخر من كتبها',
};
//# sourceMappingURL=i18n-extensions.js.map